import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowLeftX: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconArrowLeftX"><Path d="M11.2484 10L15.25 14.0017M15.2517 10L11.25 14.0017M3.92465 10.2968L6.85568 6.0468C7.41566 5.23483 8.33898 4.75 9.32532 4.75H18.25C19.9069 4.75 21.25 6.09315 21.25 7.75V16.25C21.25 17.9069 19.9069 19.25 18.25 19.25H9.32532C8.33898 19.25 7.41566 18.7652 6.85568 17.9532L3.92465 13.7032C3.2175 12.6778 3.2175 11.3222 3.92465 10.2968Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconArrowLeftX;
